import React from 'react';
import { Dialog } from '@material-ui/core';
import { ErrorProps } from './Error.interface';
import {
    StyledDialogContent,
    DialogTitle,
    DialogDescription,
    CloseButton,
    FlexWrapper
} from '../Dialogs.styles';

export function Error({ open, setOpen, message }: ErrorProps) {
    return (
        <Dialog
            open={open}
            onClose={() => setOpen(false)}
            fullWidth
        >
            <StyledDialogContent>
                <DialogTitle>Error</DialogTitle>
                <DialogDescription>{message}</DialogDescription>
                <FlexWrapper>
                    <CloseButton type="button" onClick={() => setOpen(false)}>Cancel</CloseButton>
                </FlexWrapper>    
            </StyledDialogContent>
        </Dialog>
    )
}
